import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Input } from "reactstrap";
import CustomButton from "../../CustomButton";

const ZipcodeFilter = ({
  collapsed,
  searchTerm,
  setRadius,
  setSearchTerm,
  tglHide,
  isTabletView,
  toggled,
  tempRadius,
  handleRadiusChange,
  handleRadiusCommit,
  type,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <>
      <li className="psb-menu-header">
        <span className="sidebar-header-text">FILTERS</span>
      </li>
      <li className=" ">
        <div
          className="location-filter"
          style={{ padding: collapsed ? "0" : "0 15px" }}
        >
          <h6
            className="filter-label"
            style={{
              marginBottom: "10px",
              fontWeight: "bold",
              display: collapsed ? "none" : "block",
            }}
          >
            Zipcode:
          </h6>
          <div className="d-flex gap-2">
            <Input
              placeholder="Search Your Zipcode..."
              onChange={(e) => {
                dispatch(setSearchTerm(e.target.value));
                dispatch(setRadius(15));
              }}
              value={searchTerm || ""}
              type="search"
              pattern="[0-9]*"
              onKeyDown={(e) => {
                if ((e.keyCode < 48 || e.keyCode > 57) && e.keyCode !== 8) {
                  e.preventDefault();
                }
              }}
              className="w-100"
              style={{
                border: "1px solid var(--theme-border)",
              }}
            />
            <div className="d-lg-none d-xl-none p-0">
              <CustomButton
                onClick={tglHide}
                title="Search"
                icon={null}
                className="m-0"
              >
                Search
              </CustomButton>
            </div>
          </div>
        </div>
      </li>
      {searchTerm && (
        <li className="psb-menu-item">
          <div
            className="location-filter"
            style={{
              padding: collapsed || (isTabletView && !toggled) ? "0" : "0 15px",
            }}
          >
            <h6
              className="filter-label"
              style={{
                marginBottom: "10px",
                display:
                  collapsed || (isTabletView && !toggled) ? "none" : "block",
              }}
            >
              Radius:
            </h6>
            <Input
              placeholder="Radius"
              type="range"
              min={0}
              max={100}
              onChange={handleRadiusChange}
              onMouseUp={handleRadiusCommit}
              onTouchEnd={handleRadiusCommit}
              value={tempRadius}
              className="w-100"
              step={1}
              style={{
                display:
                  collapsed || (isTabletView && !toggled) ? "none" : "block",
              }}
            />
            {!collapsed && !(isTabletView && !toggled) && (
              <p className="radius-text">{tempRadius} miles</p>
            )}
          </div>
        </li>
      )}
      {type === "bwv" && (
        <li className="psb-menu-item Business-btn mt-2">
          <CustomButton
            onClick={() => {
              navigate("/create-service");
            }}
            title="List your Business"
            icon={null}
            className="w-100 mb-3"
            style={{
              padding:
                collapsed || (isTabletView && !toggled) ? "0" : "8px 15px",
              display:
                collapsed || (isTabletView && !toggled) ? "none" : "block",
            }}
          >
            List your Business
          </CustomButton>
        </li>
      )}
    </>
  );
};

export default ZipcodeFilter;
